module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAS5JREFUaEPtWFEOgzAIhZNtnmx6stWTseBqYki70Ym2dfinwbaPB48CQucPdn5+cAC1GbwuA0T0PMC7MyKOlutmGYgA7pabAcDkAIRHnYHCEPMQkg77uxAaCkNGSnHdEEJEdeEjIpbgtgCwjmcYoPh9Bbi+y6JVl4HC8EmZO4BdKmSQA7+SGBAxKSBFMto9AAAIhS60ugzaMFB4eEvzpgFsWc0x1jSAAREDEXHNeGRocwCW8SzXcgaS3j2oJ07t5QxUZyAegCW0SxXSCETTMto9AE/i6knsV4kUBV7INNrytvEkrp3EGq4uXshiNyQ9cQMAq6Zc4+VPNtx2zhsDnvzxkGRcxipf2rm9mx/1/zLlWwHwLbAVb2sBc15M6mmzdtWz7RzA2R6X+zkDtRl4AWn4FEC1M17IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/unit.png
// module id = 0Pjp
// module chunks = 39